import * as Yup from 'yup'

export const SchemaValidation = (t) => Yup.object().shape({
  name: Yup.string().required(t('required')),
  address: Yup.string().nullable(),
  contact: Yup.object().shape({
    email: Yup.string().email("Email inválido").nullable(),
    phone: Yup.string().nullable(),
    social_media: Yup.object().shape({
      whatsapp: Yup.string().nullable(),
      facebook: Yup.string().nullable(),
      instagram: Yup.string().nullable(),
    })
  }),
  image: Yup.string().nullable(),
  active: Yup.boolean().required(t('required')),
})